import { gql } from "@apollo/client";

export const gauth_query = gql`
mutation Gauth($token: String!) {
    gauth(token: $token)
  }
`;
export const getGAuthVar = (token: string) => ({ token });
